<template>
    <div>
        <slot>
            <div class="page-breadcrumb">
                <div class="row">
                    <div class="col-md-8 align-self-center">
                        <h4 class="page-title">Setting Estimate</h4>
                    </div>
                    <div class="col-md-4 align-self-center">
                        <div class="d-flex align-items-right justify-content-end">
                            <router-link :to="{ name: 'Setting' }" class="btn btn-info btn-sm mr-2 ctrlbtn" style="margin-bottom: 10px;width: -webkit-fill-available;">
                                <i class="fas fa-arrow-left"></i>
                                Back
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <form @submit.prevent="MetSavesettingEstimate">
                            <div class="card">
                                <div class="card-body">
                                    <div class="bgloading" v-if="FormestimateSetting.isLoading">
                                        <Loader></Loader>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 ctrlbtnShow">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <router-link
                                                        :to="{ name: 'Setting' }"
                                                        class="btn btn-primary btn-sm mr-2 float-right ctrlbtn"
                                                        style="margin-bottom: 10px;width: -webkit-fill-available;"
                                                    >
                                                        CANCEL</router-link
                                                    >
                                                </div>
                                                <div class="col-md-6">
                                                    <button
                                                        class="btn btn-success btn-sm mr-2 float-right ctrlbtn"
                                                        style="margin-bottom: 10px;width: -webkit-fill-available;"
                                                        type="submit"
                                                    >
                                                        <i class="fas fa-save"></i> SAVE
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 ctrlbtnHiden">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <router-link
                                                        :to="{ name: 'Setting' }"
                                                        class="btn btn-primary btn-sm mr-2 float-right"
                                                    >
                                                        CANCEL</router-link
                                                    >
                                                    <button
                                                        class="btn btn-success btn-sm mr-2 float-right"
                                                        type="submit"
                                                    >
                                                        <i class="fas fa-save"></i> SAVE
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label
                                            for="inputPassword"
                                            class="col-sm-1 col-form-label"
                                        ></label>
                                        <div class="col-sm-11">
                                            <div style="margin-top: -15px">
                                                <div class="form-group row">
                                                    <div class="col-sm-9">
                                                        <div
                                                            class="custom-checkbox text-right"
                                                            style="
                                                                display: flex;
                                                                align-items: center;
                                                            "
                                                        >
                                                            <label
                                                                for="jobi"
                                                                class="col-sm-4 col-form-label text-right"
                                                                >Job information:</label
                                                            >
                                                            <input
                                                                type="checkbox"
                                                                class=""
                                                                id="jobi"
                                                                v-model="
                                                                    FormestimateSetting.jobinfomationcheck
                                                                "
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label
                                                        for=""
                                                        class="col-sm-3 col-form-label text-right"
                                                        >Job information:</label
                                                    >
                                                    <div class="col-sm-9">
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            v-model="
                                                                FormestimateSetting.jobinfomationtitle
                                                            "
                                                            :disabled="
                                                                FormestimateSetting.jobinfomationcheck
                                                                    ? disabled
                                                                    : ''
                                                            "
                                                        />
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label
                                                        for=""
                                                        class="col-sm-3 col-form-label text-right"
                                                        >Default job information:</label
                                                    >
                                                    <div class="col-sm-9">
                                                        <textarea
                                                            class="form-control"
                                                            id=""
                                                            rows="10"
                                                            v-model="
                                                                FormestimateSetting.jobinfomationtext
                                                            "
                                                            :disabled="
                                                                FormestimateSetting.jobinfomationcheck
                                                                    ? disabled
                                                                    : ''
                                                            "
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header">Terms & Conditions</div>
                                <div class="card-body">
                                    <div class="form-group row">
                                        <label
                                            for=""
                                            class="col-sm-2 col-form-label"
                                        ></label>
                                        <div class="col-sm-10">
                                            <div
                                                class="form-row align-items-center"
                                                style="margin-bottom: 10px"
                                            >
                                                <div class="col-auto my-1">
                                                    <label
                                                        class="mr-sm-2 sr-only"
                                                        for="inlineFormCustomSelect"
                                                        >Preference</label
                                                    >
                                                </div>
                                                <div class="col-auto my-1">
                                                    <div
                                                        class="custom-control custom-checkbox mr-sm-2"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="termsc"
                                                            v-model="
                                                                FormestimateSetting.termsconditioncheck
                                                            "
                                                        />
                                                        <label
                                                            class="custom-control-label"
                                                            for="termsc"
                                                            >Terms & Conditions:</label
                                                        >
                                                    </div>
                                                </div>
                                                <div class="col-auto my-1">
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        id=""
                                                        v-model="
                                                            FormestimateSetting.termsconditiontitle
                                                        "
                                                        :disabled="
                                                            FormestimateSetting.termsconditioncheck
                                                                ? disabled
                                                                : ''
                                                        "
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-auto">
                                                <textarea
                                                    class="form-control"
                                                    id="exampleFormControlTextarea1"
                                                    rows="10"
                                                    v-model="
                                                        FormestimateSetting.termsconditiontext
                                                    "
                                                    :disabled="
                                                        FormestimateSetting.termsconditioncheck
                                                            ? disabled
                                                            : ''
                                                    "
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 ctrlbtnShow">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <router-link
                                                        :to="{ name: 'Setting' }"
                                                        class="btn btn-primary btn-sm mr-2 float-right ctrlbtn"
                                                        style="margin-bottom: 10px;width: -webkit-fill-available;"
                                                    >
                                                        CANCEL</router-link
                                                    >
                                                </div>
                                                <div class="col-md-6">
                                                    <button
                                                        class="btn btn-success btn-sm mr-2 float-right ctrlbtn"
                                                        style="margin-bottom: 10px;width: -webkit-fill-available;"
                                                        type="submit"
                                                    >
                                                        <i class="fas fa-save"></i> SAVE
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 ctrlbtnHiden">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <router-link
                                                        :to="{ name: 'Setting' }"
                                                        class="btn btn-primary btn-sm mr-2 float-right"
                                                    >
                                                        CANCEL</router-link
                                                    >
                                                    <button
                                                        class="btn btn-success btn-sm mr-2 float-right"
                                                        type="submit"
                                                    >
                                                        <i class="fas fa-save"></i> SAVE
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
        </slot>
    </div>
</template>
<script>
import Loader from "@/core/components/shared/Loader";
export default {
    components: {
        Loader,
    },
    data() {
        return {
            disabled: false,
            FormestimateSetting: {
                isLoading: false,
                user_id: null,
                action: "Add",
                greeting: false,
                greetingFormat1: 1,
                greetingFormat2: 1,
                messagesubjet: null,
                messagetext: null,
                jobinfomationcheck: true,
                jobinfomationtitle: "Job information",
                jobinfomationtext: null,
                termsconditioncheck: false,
                termsconditiontitle: null,
                termsconditiontext: null,
            },
            DefaultMessage: {
                Subject: null,
                Message: null,
            },
        };
    },
    created() {
        this.getCompanyInfo();
    },
    mounted() {},
    methods: {
        getCompanyInfo() {
            this.isLoading = true;
            window.billing
                .get("companyinfo/" + window.localuserdata)
                .then((response) => {
                    console.log("datos company");
                    console.log(response.data);
                    this.DefaultMessage.Subject = "Estimate from %COMPANY_NAME%";
                    this.DefaultMessage.Message =
                        "Your estimate is attached. \n\nThank you for your business - we appreciate it very much.\n\n\nSincerely,\n%COMPANY_NAME%";
                    this.getEstimateSetting();
                })
                .catch((error) => console.log(error));
        },

        MetDefaultMessage() {
            console.log("creando msj por defecto");
            this.FormestimateSetting.messagesubjet = this.DefaultMessage.Subject;
            this.FormestimateSetting.messagetext = this.DefaultMessage.Message;
        },

        MetSavesettingEstimate() {
            this.FormestimateSetting.isLoading = true;
            if (this.FormestimateSetting.action == "Add") {
                window.billing
                    .post("estimates/setting", {
                        user_id: window.localuserdata,
                        greeting: this.FormestimateSetting.greeting,
                        greetingFormat1: this.FormestimateSetting.greetingFormat1,
                        greetingFormat2: this.FormestimateSetting.greetingFormat2,
                        messagesubjet: this.FormestimateSetting.messagesubjet,
                        messagetext: this.FormestimateSetting.messagetext,
                        jobinfomationcheck: this.FormestimateSetting.jobinfomationcheck,
                        jobinfomationtitle: this.FormestimateSetting.jobinfomationtitle,
                        jobinfomationtext: this.FormestimateSetting.jobinfomationtext,
                        termsconditioncheck: this.FormestimateSetting.termsconditioncheck,
                        termsconditiontitle: this.FormestimateSetting.termsconditiontitle,
                        termsconditiontext: this.FormestimateSetting.termsconditiontext,
                    })
                    .then((response) => {
                        this.FormestimateSetting.action = "Update";
                        this.FormestimateSetting.isLoading = false;
                        console.log(response.data);
                        this.$notify({
                            group: "noti",
                            title: "Created",
                            type: "success",
                            text: "Created Message Successful",
                        });
                    })
                    .catch((error) =>
                        console.log(error, (this.FormestimateSetting.isLoading = false))
                    );
            }
            if (this.FormestimateSetting.action == "Update") {
                this.FormestimateSetting.isLoading = true;
                window.billing
                    .put("estimates/setting/" + window.localuserdata, {
                        user_id: window.localuserdata,
                        greeting: this.FormestimateSetting.greeting,
                        greetingFormat1: this.FormestimateSetting.greetingFormat1,
                        greetingFormat2: this.FormestimateSetting.greetingFormat2,
                        messagesubjet: this.FormestimateSetting.messagesubjet,
                        messagetext: this.FormestimateSetting.messagetext,
                        jobinfomationcheck: this.FormestimateSetting.jobinfomationcheck,
                        jobinfomationtitle: this.FormestimateSetting.jobinfomationtitle,
                        jobinfomationtext: this.FormestimateSetting.jobinfomationtext,
                        termsconditioncheck: this.FormestimateSetting.termsconditioncheck,
                        termsconditiontitle: this.FormestimateSetting.termsconditiontitle,
                        termsconditiontext: this.FormestimateSetting.termsconditiontext,
                    })
                    .then((response) => {
                        this.FormestimateSetting.action = "Update";
                        this.FormestimateSetting.isLoading = false;
                        this.$notify({
                            group: "noti",
                            title: "Updated",
                            type: "success",
                            text: "Updated Setting Successful",
                        });
                    })
                    .catch((error) =>
                        console.log(error, (this.FormestimateSetting.isLoading = false))
                    );
            }
        },
        getEstimateSetting() {
            //this.FormestimateSetting.isLoading = true
            window.billing
                .get("estimates/setting/" + window.localuserdata)
                .then((response) => {
                    console.log(response.data.result);
                    if (response.data.result.length) {
                        this.FormestimateSetting.user_id =
                            response.data.result[0].user_id;
                        this.FormestimateSetting.greeting =
                            response.data.result[0].greeting;
                        this.FormestimateSetting.greetingFormat1 =
                            response.data.result[0].greetingFormat1;
                        this.FormestimateSetting.greetingFormat2 =
                            response.data.result[0].greetingFormat2;
                        this.FormestimateSetting.messagesubjet =
                            response.data.result[0].messagesubjet;
                        this.FormestimateSetting.messagetext =
                            response.data.result[0].messagetext;
                        this.FormestimateSetting.jobinfomationcheck =
                            response.data.result[0].jobinfomationcheck;
                        this.FormestimateSetting.jobinfomationtitle =
                            response.data.result[0].jobinfomationtitle;
                        this.FormestimateSetting.jobinfomationtext =
                            response.data.result[0].jobinfomationtext;
                        this.FormestimateSetting.termsconditioncheck =
                            response.data.result[0].termsconditioncheck;
                        this.FormestimateSetting.termsconditiontitle =
                            response.data.result[0].termsconditiontitle;
                        this.FormestimateSetting.termsconditiontext =
                            response.data.result[0].termsconditiontext;
                        if (this.FormestimateSetting.user_id !== null) {
                            this.FormestimateSetting.action = "Update";
                        }
                        this.FormestimateSetting.isLoading = false;
                    } else {
                        this.MetDefaultMessage();
                    }

                    console.log(response.data);
                })
                .catch((error) => console.log(error));
        },
    },
};
</script>
<style lang="scss" scoped>
#editor {
    height: 300px;
}

@media (min-width: 1279px) {
    .ctrlbtn {
        width:160px !important;
    }
    .ctrlbtnCustom {
        width:100px !important;
    }    
    .ctrlbtnShow {
        display: none !important;
    }    
}
@media (max-width: 1281px) {
    .ctrlbtnHiden {
        display: none !important;
    }    
}

.contenedor-table table thead tr th {
    font-weight: bold;
}
@media (max-width: 1100px) {
    .contenedor-table {
        max-width: 924px;
        overflow-x: scroll;
    }
}
</style>
